import { AxiosError } from 'axios'

export interface ValidationError {
  field: string
  message: string
}

export interface ApiErrorResponse {
  error: string
  details?: ValidationError[]
}

/**
 * Extrae los mensajes de error de una respuesta de API
 * Soporta tanto errores simples como errores de validación con detalles
 */
export function extractApiErrors(error: unknown): {
  message: string
  details: ValidationError[]
  fullMessage: string
} {
  const axiosError = error as AxiosError<ApiErrorResponse>
  const data = axiosError.response?.data

  if (!data) {
    return {
      message: 'Error de conexión con el servidor',
      details: [],
      fullMessage: 'Error de conexión con el servidor',
    }
  }

  const message = data.error || 'Ha ocurrido un error'
  const details = data.details || []

  // Construir mensaje completo con todos los detalles
  let fullMessage = message
  if (details.length > 0) {
    const detailMessages = details.map((d) => d.message).join('. ')
    fullMessage = `${message}: ${detailMessages}`
  }

  return { message, details, fullMessage }
}

/**
 * Formatea los errores de validación para mostrar en un toast
 */
export function formatValidationErrors(details: ValidationError[]): string {
  if (details.length === 0) return ''
  if (details.length === 1) return details[0].message
  return details.map((d) => `• ${d.message}`).join('\n')
}
